import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ec1ff35"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "animation-index"
}

import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import {
  ElementTypes,
  type PPTElement,
  type PPTLineElement,
  type PPTVideoElement,
  type PPTAudioElement,
  type PPTShapeElement,
  type PPTChartElement,
} from '@/types/slides'
import type { OperateLineHandlers, OperateResizeHandlers } from '@/types/edit'

import ImageElementOperate from './ImageElementOperate.vue'
import TextElementOperate from './TextElementOperate.vue'
import ShapeElementOperate from './ShapeElementOperate.vue'
import LineElementOperate from './LineElementOperate.vue'
import TableElementOperate from './TableElementOperate.vue'
import CommonElementOperate from './CommonElementOperate.vue'
import LinkHandler from './LinkHandler.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    elementInfo: {},
    isSelected: { type: Boolean },
    isActive: { type: Boolean },
    isActiveGroupElement: { type: Boolean },
    isMultiSelect: { type: Boolean },
    rotateElement: { type: Function },
    scaleElement: { type: Function },
    dragLineElement: { type: Function },
    moveShapeKeypoint: { type: Function },
    openLinkDialog: { type: Function }
  },
  setup(__props: any) {

const props = __props

const { canvasScale, toolbarState } = storeToRefs(useMainStore())
const { formatedAnimations } = storeToRefs(useSlidesStore())

const currentOperateComponent = computed<unknown>(() => {
  const elementTypeMap = {
    [ElementTypes.IMAGE]: ImageElementOperate,
    [ElementTypes.TEXT]: TextElementOperate,
    [ElementTypes.SHAPE]: ShapeElementOperate,
    [ElementTypes.LINE]: LineElementOperate,
    [ElementTypes.TABLE]: TableElementOperate,
    [ElementTypes.CHART]: CommonElementOperate,
    [ElementTypes.LATEX]: CommonElementOperate,
    [ElementTypes.VIDEO]: CommonElementOperate,
    [ElementTypes.AUDIO]: CommonElementOperate,
  }
  return elementTypeMap[props.elementInfo.type] || null
})

const elementIndexListInAnimation = computed(() => {
  const indexList = []
  for (let i = 0; i < formatedAnimations.value.length; i++) {
    const elIds = formatedAnimations.value[i].animations.map(item => item.elId)
    if (elIds.includes(props.elementInfo.id)) indexList.push(i)
  }
  return indexList
})

const rotate = computed(() => 'rotate' in props.elementInfo ? props.elementInfo.rotate : 0)
const height = computed(() => 'height' in props.elementInfo ? props.elementInfo.height : 0)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["operate", { 'multi-select': _ctx.isMultiSelect && !_ctx.isActive }]),
    style: _normalizeStyle({
      top: _ctx.elementInfo.top * _unref(canvasScale) + 'px',
      left: _ctx.elementInfo.left * _unref(canvasScale) + 'px',
      transform: `rotate(${rotate.value}deg)`,
      transformOrigin: `${_ctx.elementInfo.width * _unref(canvasScale) / 2}px ${height.value * _unref(canvasScale) / 2}px`,
    })
  }, [
    (_ctx.isSelected)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(currentOperateComponent.value), {
          key: 0,
          elementInfo: _ctx.elementInfo,
          handlerVisible: !_ctx.elementInfo.lock && (_ctx.isActiveGroupElement || !_ctx.isMultiSelect),
          rotateElement: _ctx.rotateElement,
          scaleElement: _ctx.scaleElement,
          dragLineElement: _ctx.dragLineElement,
          moveShapeKeypoint: _ctx.moveShapeKeypoint
        }, null, 8, ["elementInfo", "handlerVisible", "rotateElement", "scaleElement", "dragLineElement", "moveShapeKeypoint"]))
      : _createCommentVNode("", true),
    (_unref(toolbarState) === 'elAnimation' && elementIndexListInAnimation.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(elementIndexListInAnimation.value, (index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "index-item",
              key: index
            }, _toDisplayString(index + 1), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.isActive && _ctx.elementInfo.link)
      ? (_openBlock(), _createBlock(LinkHandler, {
          key: 2,
          elementInfo: _ctx.elementInfo,
          link: _ctx.elementInfo.link,
          openLinkDialog: _ctx.openLinkDialog,
          onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
        }, null, 8, ["elementInfo", "link", "openLinkDialog"]))
      : _createCommentVNode("", true)
  ], 6))
}
}

})